export const fields = {
  firstname: {
    label: 'First Name',
    placeholder: 'First name',
    system: {
      name: 'firstname',
      disabled: false,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'first_name',
    rules: {
      title: 'First name field',
      required: true,
    }
  },
  lastname: {
    label: 'Last Name',
    placeholder: 'Last name',
    system: {
      name: 'lastname',
      disabled: false,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'last_name',
    rules: {
      title: 'Last name field',
      required: true,
    }
  },
  username: {
    label: 'User Name',
    placeholder: 'User name',
    system: {
      name: 'username',
      disabled: false,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'user_name',
    rules: {
      title: 'User name field',
      required: true,
    }
  },
  email: {
    label: 'Email',
    placeholder: 'Email',
    system: {
      name: 'email',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'email',
    rules: {
      title: 'Email field',
      required: true,
    }
  },
  signature: {
    label: 'Signature',
    placeholder: 'Add signature',
    system: {
      name: 'signature',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'signature',
    rules: {
      title: 'Signature field'
    }
  },
  currentpassword: {
    label: 'Current Password',
    placeholder: 'Fill in this field',
    system: {
      name: 'currentpassword',
    },
    value: '',
    errors: [],
    type: 'password',
    name: 'currentpassword',
    rules: {
      title: 'This field',
    }
  },
  newpassword: {
    label: 'New Password',
    placeholder: 'Fill in this field',
    system: {
      name: 'newpassword',
    },
    value: '',
    errors: [],
    type: 'password',
    name: 'newpassword',
    rules: {
      title: 'This field',
    }
  },
  verifypassword: {
    label: 'Verify Password',
    placeholder: 'Fill in this field',
    system: {
      name: 'verifypassword',
    },
    value: '',
    errors: [],
    type: 'password',
    name: 'verifypassword',
    rules: {
      title: 'This field',
    }
  },
}



// WEBPACK FOOTER //
// ./src/containers/Profile/fields.js